import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Input, Button, Form, Select } from 'antd';
import CookieManagementService from '../../../services/CookieManagement.service';
import useNotify from '../../../context/Notification/useNotify';
import ModalDiscardChanges from '../../../components/Shared/modal/discardChanges';
import { useBlocker } from '../../../util/usePrompt';
import { useNavigate } from 'react-router-dom';

const { Option } = Select;
export default function ModalAddCookie({
    open,
    handelClose,
    setCookieDetail,
    cookieDetail,
    domainSelect,
    getCategoryDetail,
    categoryList,
    cookieCategoryId,
}) {
    const { t, i18n } = useTranslation();
    let lang = i18n.language;
    const [form] = Form.useForm();
    const { TextArea } = Input;
    const notify = useNotify();

    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);
    const [loading, setLoading] = useState(false);

    useBlocker((nextLocation) => onChangePage(nextLocation), change === true);
    const Navigate = useNavigate();

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };
    const handelOk = async () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        setOpenChange(false);
        setChange(false);
        setIsChangeLocation(false);
        // await form.resetFields();
        await getCategoryDetail();
        await form.setFieldsValue({
            cookieName: '',
            categoryId: cookieCategoryId,
            domain: '',
            duration: '',
            description: '',
        });
        await Navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
    };

    const onFinish = async (value) => {
        setLoading(true);
        if (!cookieDetail?.cookieDetailId) {
            try {
                const { data } = await CookieManagementService.createCookie({
                    cookieName: value?.cookieName,
                    categoryId: value?.categoryId,
                    domainId: domainSelect?.domainId,
                    domain: value?.domain,
                    duration: value?.duration,
                    description: value?.description,
                });
                if (data?.resultCode === 1) {
                    handelClose();
                    await notify({
                        title: t('common.Success'),
                        description: t('Successfully to save data'),
                    });
                    setChange(false);
                    await form.resetFields();
                    await form.setFieldsValue({
                        categoryId: cookieCategoryId,
                    });
                    getCategoryDetail();
                } else {
                    handelClose();
                    await notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to save data'),
                    });
                    setChange(false);
                    await form.resetFields();
                    await form.setFieldsValue({
                        categoryId: cookieCategoryId,
                    });
                    getCategoryDetail();
                }
                setLoading(false);
            } catch (error) {
                // console.log('error?.data?.errorData?.msg ',error?.data?.errorData?.msg)
                if (
                    error?.data?.errorData?.msg ===
                    'THIS COOKIE NAME ALREADY EXIST.'
                ) {
                    form.setFields([
                        {
                            name: 'cookieName',
                            errors: [t('CookieCategory.CookieNameExist')],
                        },
                    ]);
                } else {
                    handelClose();
                    await notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to save data'),
                    });
                    await form.resetFields();
                    await form.setFieldsValue({
                        categoryId: cookieCategoryId,
                    });
                    getCategoryDetail();
                }
                setLoading(false);
            }
        } else {
            try {
                const { data } = await CookieManagementService.updateCookie({
                    cookieDetailId: cookieDetail?.cookieDetailId,
                    cookieName: value?.cookieName,
                    categoryId: value?.categoryId,
                    domainId: domainSelect?.domainId,
                    domain: value?.domain,
                    duration: value?.duration,
                    description: value?.description,
                });
                if (data?.resultCode === 1) {
                    handelClose();
                    await notify({
                        title: t('common.Success'),
                        description: t('Successfully to save data'),
                    });
                    await form.resetFields();
                    await form.setFieldsValue({
                        categoryId: cookieCategoryId,
                    });
                    setChange(false);
                    getCategoryDetail();
                } else {
                    handelClose();
                    await notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to save data'),
                    });
                    await form.resetFields();
                    await form.setFieldsValue({
                        categoryId: cookieCategoryId,
                    });
                    setChange(false);
                }
                setLoading(false);
            } catch (error) {
                if (
                    error?.data?.errorData?.msg ===
                    'THIS COOKIE NAME ALREADY EXIST.'
                ) {
                    form.setFields([
                        {
                            name: 'cookieName',
                            errors: [t('CookieCategory.CookieNameExist')],
                        },
                    ]);
                } else {
                    handelClose();
                    await notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to save data'),
                    });
                    await form.resetFields();
                    await form.setFieldsValue({
                        categoryId: cookieCategoryId,
                    });
                    setChange(false);
                }
                console.log(error);
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        if (cookieDetail && cookieCategoryId) {
            form.setFieldsValue({
                ...cookieDetail,
                categoryId: cookieCategoryId,
            });
            setChange(false);
        } else {
            form.setFieldsValue({
                categoryId: cookieCategoryId,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cookieDetail, domainSelect, cookieCategoryId]);

    const onCategoryChange = async (value) => {
        form.setFieldsValue({
            categoryId: value,
        });
    };
    return (
        <>
            <Modal
                width={500}
                className="_modal"
                footer={false}
                open={open}
                onCancel={() => {
                    if (change === true) {
                        setOpenChange(true);
                        setIsChangeLocation(true);
                    } else {
                        setChange(false);
                        handelClose();
                        form.resetFields();
                        setCookieDetail();
                    }
                }}
            >
                <>
                    <div className="text-[22px] text-center my-6">
                        {!cookieDetail?.cookieDetailId
                            ? t('COOKIE.AddCookie')
                            : t('COOKIE.EditCookie')}
                    </div>
                    <Form
                        scrollToFirstError={{
                            behavior: 'smooth',
                            block: 'center',
                        }}
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                        onFieldsChange={(_, allFields) => {
                            if (allFields.length > 0) {
                                setChange(true);
                            }
                        }}
                    >
                        <Form.Item
                            label={t('COOKIE.CookieName')}
                            name="cookieName"
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <Input
                                placeholder={t('COOKIE.CookieName')}
                                size="large"
                                showCount
                                maxLength={30}
                            />
                        </Form.Item>
                        <Form.Item
                            label={t('Category')}
                            name="categoryId"
                            className="w-full mb-0"
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.children ?? '')
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                size="large"
                                onChange={onCategoryChange}
                                placeholder={t('MyTask.PleaseSelect')}
                            >
                                {categoryList?.map((e) => (
                                    <Option
                                        key={e?.cookieCategoryId}
                                        value={e?.cookieCategoryId}
                                    >
                                        {lang === 'en'
                                            ? e.categoryNameEn
                                            : e.categoryNameTh}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label={t('Domain')}
                            name="domain"
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <Input placeholder={t('Domain')} size="large" />
                        </Form.Item>
                        <Form.Item
                            label={t('COOKIE.Duration')}
                            name="duration"
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <Input
                                placeholder={t('COOKIE.PlaceholderEx')}
                                size="large"
                            />
                        </Form.Item>
                        <Form.Item
                            label={t('COOKIE.Description')}
                            name={'description'}
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <TextArea
                                size="large"
                                className="bg-[#F4F6FC]"
                                autoSize={{ minRows: 4, maxRows: 6 }}
                                placeholder={t('COOKIE.DescribeDetails')}
                            />
                        </Form.Item>
                        <div className="flex justify-center items-center py-4 space-x-4">
                            <Button
                                type="primary"
                                size="large"
                                className="w-32"
                                ghost
                                onClick={() => {
                                    if (change === true) {
                                        setOpenChange(true);
                                        setIsChangeLocation(true);
                                    } else {
                                        handelClose();
                                        form.resetFields();
                                        setCookieDetail();
                                    }
                                }}
                            >
                                {t('common.Cancel')}
                            </Button>
                            <Button
                                className="w-32"
                                htmlType="submit"
                                size="large"
                                type="primary"
                                loading={loading}
                            >
                                {t('common.Save')}
                            </Button>
                        </div>
                    </Form>
                </>
            </Modal>
            <ModalDiscardChanges
                open={openChange}
                handelOk={() => {
                    if (isChangeLocation) {
                        handelOkLocation();
                        handelClose();
                    } else {
                        handelOk();
                        setChange(false);
                    }
                }}
                handelClose={() => {
                    setOpenChange(false);
                }}
            />
        </>
    );
}
